import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import img1 from "../../assets/Instagram/portfolioInsta1.png";
import img2 from "../../assets/Instagram/portfolioInsta2.png";

const Instagram = () => {
  const dataContext = useContext(AuthContext);
  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`w-full px-4 sm:px-10 md:px-20 transition-all duration-500 ${
        theme === "dark" ? "bg-white text-black" : "bg-black text-white"
      }`}
    >
      <section className="max-w-[1536px] mx-auto py-3 md:py-0 transition-all duration-500">
        {/* Header Section */}
        <div className="flex flex-col justify-center items-center mb-3  md:mb-10">
          <h2
            className={`bricolage-grotesque-bold text-2xl sm:text-3xl md:text-[32px] px-3 sm:px-4 py-1.5 sm:py-2 rounded-full font-semibold text-center transition-all duration-500 ${
              theme === "dark"
                ? "bg-[#f5f5f5] text-black"
                : "bg-[#232323] text-white"
            }`}
          >
            INSTAGRAM
          </h2>
        </div>

        {/* Grid Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
          <div className="border overflow-hidden">
            <p className="montserrat-medium p-4">@dikshainaction</p>
            <img
              src={img1}
              alt="Social Design 1"
              className="w-full h-auto object-cover rounded-lg transition-transform duration-500 ease-in-out hover:scale-105"
            />
          </div>
          <div className="border overflow-hidden">
            <p className="montserrat-medium p-4">@craigsteven</p>
            <img
              src={img2}
              alt="Social Design 2"
              className="w-full h-auto object-cover rounded-lg transition-transform duration-500 ease-in-out hover:scale-105"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Instagram;
